import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d5f05c48&scoped=true&"
import script from "./404.vue?vue&type=script&async=true&lang=js&"
export * from "./404.vue?vue&type=script&async=true&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&id=d5f05c48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f05c48",
  null
  
)

export default component.exports